import axios, { CancelTokenSource } from 'axios';
import {
  BroadcastEmailDto,
  BroadcastEmailRun,
  BroadcastEmailSearchRequest,
  PatientEmailImportDto
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/email-broadcast`;

export const sendBroadcastEmails = (
    emails: PatientEmailImportDto[],
    emailCampaignId: number,
    source: CancelTokenSource): Promise<BroadcastEmailRun> => {

  return axios
      .post(`${apiUri}/send-emails`,
          emails,
          {
            params: {emailCampaignId: emailCampaignId},
            cancelToken: source.token
          })
      .then(response => response.data);
}

export const getBroadcastEmailRuns = (source: CancelTokenSource):
    Promise<BroadcastEmailRun[]> => {

  return axios
      .get(`${apiUri}/run`, {cancelToken: source.token})
      .then(response => response.data);
}

export const searchRuns = (
    broadcastEmailSearchRequest: Partial<BroadcastEmailSearchRequest>,
    source: CancelTokenSource): Promise<BroadcastEmailDto[]> => {

  return axios.post(
          `${apiUri}/search`, broadcastEmailSearchRequest, {cancelToken: source.token})
      .then(response => response.data);
}
